import React from 'react';
import classNames from 'classnames';

export interface IWFNXCardBodyProps {
  children?: React.ReactNode;
  className?: string;
}

export class WFNXCardBody extends React.Component<IWFNXCardBodyProps, any> {
  render() {
    const { className } = this.props;

    return (
      <div className={classNames('wfnx-small-card-body', className)}>
        {this.props.children}
      </div>
    );
  }
}
